import { ValidatorService } from '../tools/validator.service';
import { AutenticacionService } from '../autenticacion.service';
import { Http } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from '../tools/errors.service';

@Injectable()
export class VerdesService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/creditosVerdes';
  }

  public get(idCreditos : number){
    const service = this.service_url + '/' + idCreditos;
    return this.http.get(service  , this.authService.getAuthHeaders());
  }

  public save( credito : object) {
    return this.http.post(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public update( credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public updateAvaluo( creditoVerde : object) {
    return this.http.put(this.service_url + '/avaluos' , creditoVerde, this.authService.getAuthHeaders());
  }

  public updateCapacidadPago( creditoVerde : object) {
    return this.http.put(this.service_url + '/capacidadPago' , creditoVerde, this.authService.getAuthHeaders());
  }

  public validate(credito : any){
    let error = [];
    let prestamo = credito.prestamo;
    let cliente = credito.cliente;
    let verde = credito.verde;

    if(!this.validatorService.required(prestamo.monto_prestamo)){
        error["monto_prestamo"] = this.errorService.required;
    }

    if(!this.validatorService.required(prestamo.tasa)){
        error["tasa"] = this.errorService.required;
    }

    if(!this.validatorService.required(prestamo.plazo_periodo)){
        error["plazo_periodo"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.nombre)){
        error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(cliente.email)){
        error["email"] = this.errorService.required;
    }else if (!this.validatorService.email(cliente.email)) {
        error['email'] = this.errorService.email;
    }

    if(!this.validatorService.required(verde.precio_equipo)){
        error["precio_equipo"] = this.errorService.required;
    }

    if(!this.validatorService.required(verde.enganche)){
        error["enganche"] = this.errorService.required;
    }

    return error;
  }

  public validateAvaluo(data : any){
    let error = [];
    
    if(!this.validatorService.required(data.precio_equipo)){
      error["precio_equipo"] = this.errorService.required;
    }    
    
    if(!this.validatorService.required(data.enganche)){
      error["enganche"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.proveedor)){
      error["proveedor"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.descripcion_garantia)){
      error["descripcion_garantia"] = this.errorService.required;
    }

    return error;
  }

  public validateCapacidadPago(data : any){
    let error = [];
    
    if(!this.validatorService.required(data.capacidad_pago)){
      error["capacidad_pago"] = this.errorService.required;
    }    

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/creditos/verdes.service.ts